<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="$can('partner.list')">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="openModal()">
                      <i class="mdi mdi-plus mr-1"></i> Nova Categoria
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Cor</th>
                    <th>Ordem</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in categories" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td><span v-if="item.color" class="color-badge" :style="{ background: item.color }"></span></td>
                    <td>{{ item.sequence }}</td>
                    <td>
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0" v-if="$can('partner.list')">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item @click="openModal(item)">
                          <i class="fas fa-pencil-alt text-success mr-1"></i> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteCategory(item.id)">
                          <i class="fas fa-trash-alt text-danger mr-1"></i> Excluir
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="modal" :title="modalTitle" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
      <div class="form-group">
        <label for="categoryName">Nome</label>
        <input
          id="categoryName"
          v-model="form.name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': submitted && !form.name }"
        />
        <div v-if="submitted && !form.name" class="invalid-feedback">
          O campo nome é obrigatório.
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="categoryColor">Cor</label>
        <div class="d-flex align-items-center">
          <input
            id="categoryColor"
            v-model="form.color"
            type="color"
            class="form-control form-control-color"
            style="width: 50px; height: 38px; padding: 2px;"
          />
          <input
            v-model="form.color"
            type="text"
            class="form-control ml-2"
            placeholder="#000000"
            maxlength="7"
          />
        </div>
      </div>
      <div class="form-group mt-3">
        <label for="categorySequence">Ordem</label>
        <input
          id="categorySequence"
          v-model="form.sequence"
          type="number"
          class="form-control"
        />
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeModal()">Cancelar</b-button>
        <button type="button" class="btn btn-primary" @click="saveCategory()">Salvar</button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState, mapGetters } from 'vuex'
import permissionMixin from '@/mixins/permissionMixin'

export default {
  mixins: [permissionMixin],
  components: {
    Layout,
    PageHeader
  },
  name: 'PartnerCategories',
  page: {
    title: 'Categorias de Parceiros',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      modal: false,
      modalTitle: 'Nova Categoria',
      form: { name: '', sequence: 0, color: '#000000' },
      submitted: false,
      title: 'Categorias de Parceiros',
      items: [{
        text: 'Parceiros'
      },
      {
        text: 'Categorias',
        active: true
      }]
    }
  },
  mounted () {
    this.updateList()
  },
  computed: {
    ...mapGetters('partnerCategory', { categories: 'PARTNER_CATEGORIES' }),
    ...mapState('partnerCategory', ['pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('partnerCategory', {
      getAll: 'getAll',
      saveAction: 'save',
      destroyAction: 'destroy'
    }),
    openModal (item = null) {
      this.submitted = false
      if (item) {
        this.modalTitle = 'Editar Categoria'
        this.form = { id: item.id, name: item.name, sequence: item.sequence, color: item.color || '#000000' }
      } else {
        this.modalTitle = 'Nova Categoria'
        this.form = { name: '', sequence: 0, color: '#000000' }
      }
      this.modal = true
    },
    closeModal () {
      this.modal = false
      this.form = { name: '', sequence: 0, color: '#000000' }
      this.submitted = false
    },
    async saveCategory () {
      this.submitted = true
      if (!this.form.name) return

      try {
        await this.saveAction(this.form)
        successMessage('Sucesso: Categoria salva com sucesso.', 2500)
        this.closeModal()
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteCategory (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyAction(id)
            successMessage('Sucesso: Categoria excluída com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.updateList()
    },
    updateList () {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.table-responsive { min-height: 300px; }
.float-sm-end { float: right }
.color-badge {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}
.ml-2 { margin-left: 0.5rem; }
</style>
